import { useAuthStore } from '@/stores/auth';

/**
 * Composable to find the first accessible route in a list of routes
 * It checks if the user has the required permission to access the route.
 * If the user does not have the required permission, it returns null.
 * If the user has the required permission, it returns the route.
 *
 * @param {import('vue-router').RouteRecordRaw[]} routes - The routes to check
 * @returns {import('vue-router').RouteRecordRaw | null} - The first accessible route or null if no accessible route is found
 */
export function useFirstAccessibleRoute(routes = [], fallbackRoute = { name: 'not-found' }) {
  const authStore = useAuthStore();

  for (const route of routes) {
    if (authStore.hasPermission(route.meta.permission)) {
      return route;
    }
  }
  return fallbackRoute;
}
